import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpEditProjectEvaluationScales, HttpEditProjectScalesOptions} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {EvaluationScaleExtended} from '@/features/projects/types'

export const useEditProjectEvaluationScales = ({
    urlParams,
    options
}: {
    urlParams: HttpEditProjectScalesOptions['urlParams']
    options?: UseMutationOptions<EvaluationScaleExtended[], unknown, EvaluationScaleExtended[]>
}) =>
    useMutation({
        ...options,
        mutationFn: payload => httpEditProjectEvaluationScales({urlParams, payload}),
        // The caller optimistically patches the project cache via setQueriesData, but progressStatus is
        // backend-computed: invalidate to refetch so the header badge reflects the new completion state.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
